const initialState = {
  vehicles: {
    data: [
      {
        id: 1,
        vehicleNo: "KL55AA5544",
        vehicleName: "BharatBenz Truck",
        rent: 500,
        balance: 1200,
        type: "own",
        mobile: null,
      },
      {
        id: 2,
        vehicleNo: "KL55AA5544",
        vehicleName: "Leyland Truck",
        rent: 700,
        balance: 1200,
        type: "own",
        mobile: null,
      },
      {
        id: 3,
        vehicleNo: "KL55AA5544",
        vehicleName: "JCB",
        rent: 900,
        balance: 1200,
        type: "rent",
        mobile: 9632587410,
      },
      {
        id: 4,
        vehicleNo: "KL55AA5544",
        vehicleName: "Hitachy Mini Excavator",
        rent: 750,
        balance: 1200,
        type: "rent",
        mobile: 9632587410,
      },
      {
        id: 5,
        vehicleNo: "KL55AA5544",
        vehicleName: "Eicher Truck",
        rent: 1000,
        balance: 1200,
        type: "own",
        mobile: null,
      },
    ],
  },
};

export const vehicle_reducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_VEHICLES":
      return {
        ...state,
        vehicles: action.payload,
      };
    case "ADD_VEHICLE":
      return {
        ...state,
        vehicles: [...state.vehicles, action.payload],
      };
    default:
      return state;
  }
};
